(function() {
  'use strict';

  let swiperInstances = new WeakMap();

  const initSection = (section) => {
    // Skip if already initialized
    if (swiperInstances.has(section)) return;

    const el = section.querySelector('.pcd-content');
    if (!el) return;

    const row = section.querySelector('.pcd-row');
    if (!row) return;

    const layout = el.dataset.layout || 'slider';
    const spaceBetweenMobile = parseFloat(el.dataset.spaceBetweenMobile) || 10;
    const slidesPerViewMobile = parseFloat(el.dataset.slidesPerViewMobile) || 1.3;
    const spaceBetweenTablet = parseFloat(el.dataset.spaceBetweenTablet) || 15;
    const slidesPerViewTablet = parseFloat(el.dataset.slidesPerViewTablet) || 2;
    const spaceBetween = parseFloat(el.dataset.spaceBetweenDesktop) || 20;
    const slidesPerView = parseFloat(el.dataset.slidesPerViewDesktop) || 3;
    const gridColumnsMobile = parseInt(el.dataset.gridColumnsMobile) || 1;
    const gridColumnsTablet = parseInt(el.dataset.gridColumnsTablet) || 2;
    const gridColumns = parseInt(el.dataset.gridColumns) || 3;
    const gridGapMobile = parseFloat(el.dataset.gridGapMobile) || 10;
    const gridGapTablet = parseFloat(el.dataset.gridGapTablet) || 15;
    const gridGap = parseFloat(el.dataset.gridGapDesktop) || 20;

    // Apply grid styles (always needed for CSS variables)
    const applyGridStyles = () => {
      const root = document.documentElement;
      
      root.style.setProperty('--pcd-grid-columns-mobile', gridColumnsMobile);
      root.style.setProperty('--pcd-grid-columns-tablet', gridColumnsTablet);
      root.style.setProperty('--pcd-grid-columns', gridColumns);
      root.style.setProperty('--pcd-grid-gap-mobile', gridGapMobile + 'px');
      root.style.setProperty('--pcd-grid-gap-tablet', gridGapTablet + 'px');
      root.style.setProperty('--pcd-grid-gap', gridGap + 'px');
    };

    // Initialize Swiper only if slider layout is selected (classes already in HTML)
    const initializeSwiper = () => {
      if (typeof Swiper === 'undefined') return false;
      
      // Only initialize if swiper classes are already present (slider layout)
      if (!el.classList.contains('swiper')) return false;

      // Check if already initialized
      if (el.swiper) {
        el.swiper.update();
        return true;
      }

      // Determine initial values based on viewport
      const isDesktop = window.innerWidth >= 1200;
      const isTablet = window.innerWidth >= 750 && window.innerWidth < 1200;

      let initialSpaceBetween = spaceBetweenMobile;
      let initialSlidesPerView = slidesPerViewMobile;

      if (isDesktop) {
        initialSpaceBetween = spaceBetween;
        initialSlidesPerView = slidesPerView;
      } else if (isTablet) {
        initialSpaceBetween = spaceBetweenTablet;
        initialSlidesPerView = slidesPerViewTablet;
      }

      const swiper = new Swiper(el, {
        spaceBetween: initialSpaceBetween,
        slidesPerView: initialSlidesPerView,
        grabCursor: true,
        keyboard: true,
        navigation: {
          nextEl: section.querySelector('.swiper-button-next'),
          prevEl: section.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          750: {
            spaceBetween: spaceBetweenTablet,
            slidesPerView: slidesPerViewTablet,
          },
          1200: {
            spaceBetween: spaceBetween,
            slidesPerView: slidesPerView,
          },
        },
      });

      swiperInstances.set(section, swiper);
      return true;
    };

    // Apply grid styles
    applyGridStyles();

    // Initialize Swiper if needed
    if (layout === 'slider') {
      if (typeof Swiper !== 'undefined') {
        initializeSwiper();
      } else {
        // Wait for Swiper to load
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            if (initializeSwiper()) {
              // Swiper initialized successfully
            }
          }
        }, 100);
      }
    }
  };

  // Initialize on DOM ready
  const initAll = () => {
    const sections = document.querySelectorAll('.product-card-dinamic');
    sections.forEach(section => {
      initSection(section);
    });
  };

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize when Shopify theme editor updates (for live preview)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.product-card-dinamic') || event.target.closest('.product-card-dinamic');
      if (section) {
        // Remove old instance if exists
        const el = section.querySelector('.pcd-content');
        if (el && el.swiper) {
          el.swiper.destroy(true, true);
        }
        swiperInstances.delete(section);
        initSection(section);
      }
    });
  }

  // Also listen for mutations in case DOM is updated
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          const section = node.classList?.contains('product-card-dinamic') 
            ? node 
            : node.querySelector?.('.product-card-dinamic');
          if (section) {
            initSection(section);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
